// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"812be893","787":"6a29daa3"}[chunkId] + ".chunk.js";
};